import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Services from '../../../components/services/index';
import Invoices from '../../../components/invoices/index';
// import Payments from '../../../components/payments';
import PaymentHistory from '../../../components/paymentHistory';
import CreateColleague from '../../../components/createColleague';
import useStyles from '../styles/index';
import { getIMCclientDetails } from '../../users/store/actions/index';
import FileModal from '../../../components/modal/fileModal';
import ClientMasterCreation from '../../../components/clientMasterCreation/index';
import MyTicketSupportTiles from '../../../components/supportCardTiles/myTicketSupportTiles';
import AdminPaymentHistory from '../../../components/adminPaymentHistory';
// import PendingInvoicesTiles from '../../../components/pendingInvoiceTiles';
import CreateServices from '../../../components/services/createService';
// import ItecOpen from '../../../components/iTecOpen';
import CreateEmployee from '../../../components/createEmployee/index';
import BankDetails from '../../../components/bankDetails/index';
import ViewPayments from '../../../components/viewPayments/index';
// import TotalItecEmp from '../../../components/totalItecEmp/index';
import CreateClient from '../../../components/createClient/index';
import GenerateInvoices from '../../../components/invoices/generateInvoiceTiles';
import MyInvoices from '../../../components/invoices/myInvoiceTiles';

function UltimateCorporateDashboard(props) {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch({});

    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const corpUserType = userDetails.result && userDetails.result.data.message;
    const [openCorpModal, setOpenCorpModal] = React.useState(false);
    const [openModal, setOpenModal] = React.useState(false);
    const userType = userDetails && userDetails.result && userDetails.result.data && userDetails.result.data.userType;
    const gstFiles = userDetails && userDetails.result && userDetails.result.data && userDetails.result.data.gstFiles;
    // const aadharFiles = userDetails && userDetails.result && userDetails.result.data && userDetails.result.data.aadharFiles;
    const panFiles = userDetails && userDetails.result && userDetails.result.data && userDetails.result.data.panFiles;
    // Menu related Tiles
    // const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    // const userType = userDetails.result && userDetails.result.data.features[0].roleText;
    // const roleText = userDetails.result && userDetails.result.data.features[0].roleText;
    // const roleId = userDetails.result && userDetails.result.data.features[0].roleId;
    // console.log('userDetails', userDetails);
    const clientFeature = userDetails.result && userDetails.result.data.features[4].subFeatures[0].isActive;
    const bankFeature = userDetails.result && userDetails.result.data.features[1].subFeatures[2].isActive;
    const imcViewFeature = userDetails.result && userDetails.result.data.features[2].subFeatures[0].isActive;
    const itecViewFeature = userDetails.result && userDetails.result.data.features[0].subFeatures[1].isActive;
    const adminViewPaymentFeature = userDetails.result && userDetails.result.data.features[7].subFeatures[1].isActive;
    const openServiceViewFeature = userDetails.result && userDetails.result.data.features[5].subFeatures[1].isActive;
    const createServiceViewFeature = userDetails.result && userDetails.result.data.features[5].subFeatures[0].isActive;
    const InvoiceFeature = userDetails.result && userDetails.result.data.features[6].subFeatures[4].isActive;
    const generateInvoiceFeature = userDetails.result && userDetails.result.data.features[6].subFeatures[2].isActive;
    const myInvoiceFeature = userDetails.result && userDetails.result.data.features[6].subFeatures[3].isActive;
    const supportTicketsFeature = userDetails.result && userDetails.result.data.features[8].subFeatures[1].isActive;
    // const pendingInvoiceFeature = userDetails.result && userDetails.result.data.features[9].subFeatures[0].isActive;
    const paymentHistoryFeature = userDetails.result && userDetails.result.data.features[7].subFeatures[3].isActive;
    const adminPaymentHistoryFeature = userDetails.result && userDetails.result.data.features[7].subFeatures[2].isActive;

    useEffect(() => {
        if (panFiles !== null || gstFiles !== null) {
            if (userType === 'CORPORATE' && (!panFiles || !gstFiles)) {
                setOpenCorpModal(true);
                setOpenModal(false);
            }
        }
        history.push({
            state: { breadCrumbLabel: props.breadCrumbLabel, breadCrumbPath: props.breadCrumbPath },
        });
        dispatch(getIMCclientDetails());
    }, []);
    const loadCreateColleague = () => {
        if (corpUserType !== 'primary: false') {
            return (
                <Grid item sm={3} xs={12}>
                    <CreateColleague />
                </Grid>
            );
        }
        // else {
        //     return '';
        // }
    };

    const handleDialogClose = () => {
        ////console.log('close', openModal)
        setOpenModal(false);
        setOpenCorpModal(false);
    };

    const handleLogout = () => {
        history.push('/');
        localStorage.clear();
        sessionStorage.clear();
    };

    return (
        <div className={classes.dashboardmaindiv}>
            <Grid container spacing={3}>
                {/* <Grid item sm={3} xs={12}>
                    <Services />
                </Grid>
                <Grid item sm={3} xs={12}>
                    <Invoices />
                </Grid>
                <Grid item sm={3} xs={12}>
                    <Payments />
                </Grid>
                <Grid item sm={3} xs={12}>
                    <PaymentHistory />
                </Grid> */}
                {imcViewFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <CreateClient />
                    </Grid>
                ) : null}
                {itecViewFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <CreateEmployee />
                    </Grid>
                ) : null}
                {bankFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <BankDetails />
                    </Grid>
                ) : null}
                {adminViewPaymentFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <ViewPayments />
                    </Grid>
                ) : null}
                {createServiceViewFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <CreateServices />
                    </Grid>
                ) : null}
                {openServiceViewFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <Services />
                    </Grid>
                ) : null}
                {InvoiceFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <Invoices />
                    </Grid>
                ) : null}
                {myInvoiceFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <MyInvoices />
                    </Grid>
                ) : null}

                {/* {pendingInvoiceFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <PendingInvoicesTiles />
                    </Grid>
                ) : null} */}

                {/* {supportTicketsFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        
                        <SupportCardTiles />
                    </Grid>
                ) : null} */}
                {supportTicketsFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <MyTicketSupportTiles />
                    </Grid>
                ) : null}
                {/* {clientFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <ItecOpen />
                    </Grid>
                ) : null} */}
                {clientFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <ClientMasterCreation />
                    </Grid>
                ) : null}
                {paymentHistoryFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <PaymentHistory />
                    </Grid>
                ) : null}
                {adminPaymentHistoryFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <AdminPaymentHistory />
                    </Grid>
                ) : null}
                {generateInvoiceFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <GenerateInvoices />
                    </Grid>
                ) : null}

                {loadCreateColleague()}
            </Grid>
            <FileModal
                openModal={openModal}
                openCorpModal={openCorpModal}
                handleDialogClose={handleDialogClose}
                handleLogout={handleLogout}
            />
        </div>
    );
}

export default UltimateCorporateDashboard;
